import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { Card, Form, Container, Row, Col, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const PreformaInvoice = () => {
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState('');
  const [selectedServiceObj, setSelectedServiceObj] = useState(null);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [selectedPlanObj, setSelectedPlanObj] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [maxAmount, setMaxAmount] = useState(0);
  const [amountError, setAmountError] = useState('');
  const [remarks, setRemarks] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [loading, setLoading] = useState(false);
  const [agreementId, setAgreementId] = useState(null);
  const navigate = useNavigate();

  // Fetch only users who have "Accounting And Bookkeeping Services"
  useEffect(() => {
  const fetchUsersWithService = async () => {
    try {
      const res = await fetch('https://apiaksharaconnect.aksharafinalytics.in/users');
      const data = await res.json();
      const allUsers = data.user || [];
      const filteredUsers = [];

      for (const user of allUsers) {
        try {
          const detailRes = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/userdetails/${user.id}`);
          const detailData = await detailRes.json();
          const userDetails = detailData.userdetails || [];

          const hasAccountingService = userDetails.some(
            (detail) => detail.service_name === 'Accounting And Bookkeeping Services'
          );

          // ✅ Define it BEFORE using
          const accountingDetail = userDetails.find(
            (detail) => detail.service_name === 'Accounting And Bookkeeping Services'
          );

          if (accountingDetail?.agreement_id && user.id === selectedUserId) {
            setAgreementId(accountingDetail.agreement_id);
          }

          if (hasAccountingService) {
            filteredUsers.push(user);
          }
        } catch (err) {
          console.error(`Error fetching details for user ${user.id}:`, err);
        }
      }

      setUsers(filteredUsers);
    } catch (err) {
      console.error('Error fetching users:', err);
    }
  };

  fetchUsersWithService();
}, [selectedUserId]);


  useEffect(() => {
  if (selectedUserId) {
    fetch(`https://apiaksharaconnect.aksharafinalytics.in/userdetails/${selectedUserId}`)
      .then((res) => res.json())
      .then((data) => {
        const userDetails = data.userdetails || [];

        const groupedServices = Object.values(
          userDetails.reduce((acc, item) => {
            if (
              item.service_name !== 'Accounting And Bookkeeping Services'
            ) {
              return acc; // Skip other services
            }

            if (!acc[item.service_id]) {
              acc[item.service_id] = {
                service_id: item.service_id,
                service_name: item.service_name,
                total_amount: Number(item.due) || 0,
                plans: [],
              };
            }

            acc[item.service_id].plans.push({
              plan_id: item.plan_id,
              plan_name: item.plan_name,
              plan_price: Number(item.plan_price),
            });

            return acc;
          }, {})
        );

        setServices(groupedServices);
        setSelectedService('');
        setPlans([]);
        setSelectedPlan('');
        setSelectedPlanObj(null);
        setSelectedServiceObj(null);
        setTotalAmount(0);
        setMaxAmount(0);
        setAmountError('');
      })
      .catch((err) => console.error('Error fetching user details:', err));
  } else {
    setServices([]);
    setPlans([]);
    setSelectedService('');
    setSelectedServiceObj(null);
    setSelectedPlan('');
    setSelectedPlanObj(null);
    setTotalAmount(0);
    setMaxAmount(0);
    setAmountError('');
  }
}, [selectedUserId]);


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedUserId || !selectedService || !selectedPlanObj) {
      setMessage('Please fill in all required fields.');
      setMessageType('danger');
      return;
    }

    if (totalAmount <= 0) {
      setMessage('Total amount must be greater than 0.');
      setMessageType('danger');
      return;
    }

    if (totalAmount > maxAmount) {
      setMessage(`Total amount cannot exceed ₹${maxAmount}.`);
      setMessageType('danger');
      return;
    }

    setLoading(true);

    const formData = {
      agreement_id: agreementId,
      user_id: selectedUserId,
      service_id: selectedService,
      plan_id: selectedPlanObj.plan_id,
      total_amount: totalAmount,
      remarks: remarks,
    };

    console.log(formData);

    fetch('https://apiaksharaconnect.aksharafinalytics.in/proforma', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          setMessage('Proforma Invoice Generated successfully & Email sent.');
          setMessageType('success');
          setSelectedUserId('');
          setSelectedService('');
          setSelectedPlan('');
          setSelectedPlanObj(null);
          setTotalAmount(0);
          setRemarks('');
        } else {
          setMessage(data.message || 'Failed to add payment. Please check all fields again.');
          setMessageType('danger');
        }
      })
      .catch((error) => {
        console.error('Error submitting form:', error);
        setMessage('An error occurred while submitting the form.');
        setMessageType('danger');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Header />
      <Container className="mt-5">
        {message && (
          <Alert variant={messageType} onClose={() => setMessage('')} dismissible>
            {message}
          </Alert>
        )}
        <Card className="shadow">
          <Card.Header>
            <h2>Proforma Invoice &nbsp;<button className="btn btn-primary" onClick={() => navigate('/ProformaList')}>
              Proforma List
            </button></h2>
          </Card.Header>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              {/* User Dropdown */}
              <Form.Group as={Row} controlId="userSelect">
                <Form.Label column sm={2}>User</Form.Label>
                <Col sm={10}>
                  <Form.Select
                    value={selectedUserId}
                    onChange={(e) => setSelectedUserId(e.target.value)}
                    required
                  >
                    <option value="">-- Select User --</option>
                    {users.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.company}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Form.Group>

              {/* Service Dropdown */}
              {services.length > 0 && (
                <Form.Group as={Row} controlId="serviceSelect" className="mt-3">
                  <Form.Label column sm={2}>Service</Form.Label>
                  <Col sm={10}>
                    <Form.Select
                      value={selectedService}
                      required
                      onChange={(e) => {
                        const selectedServiceId = e.target.value;
                        setSelectedService(selectedServiceId);

                        const matchedService = services.find(
                          (service) => service.service_id === selectedServiceId
                        );

                        if (matchedService) {
                          setSelectedServiceObj(matchedService);
                          setPlans(matchedService.plans || []);
                          setSelectedPlan('');
                          setSelectedPlanObj(null);
                          setAmountError('');
                          setTotalAmount(0);
                          setMaxAmount(0);
                        } else {
                          setSelectedServiceObj(null);
                          setPlans([]);
                          setSelectedPlan('');
                          setSelectedPlanObj(null);
                          setTotalAmount(0);
                          setMaxAmount(0);
                          setAmountError('');
                        }
                      }}
                    >
                      <option value="">-- Select Service --</option>
                      {services.map((service) => (
                        <option key={service.service_id} value={service.service_id}>
                          {service.service_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
              )}

              {/* Plan Dropdown */}
              {plans.length > 0 && (
                <Form.Group as={Row} controlId="planSelect" className="mt-3">
                  <Form.Label column sm={2}>Plan</Form.Label>
                  <Col sm={10}>
                    <Form.Select
                      value={selectedPlan}
                      required
                      onChange={(e) => {
                        const planId = e.target.value;
                        const foundPlan = plans.find((plan) => plan.plan_id.toString() === planId);
                        setSelectedPlan(planId);
                        setSelectedPlanObj(foundPlan || null);

                        if (foundPlan) {
                          setTotalAmount(foundPlan.plan_price);
                          setMaxAmount(foundPlan.plan_price);
                        }

                      }}
                    >
                      <option value="">-- Select Plan --</option>
                      {plans.map((plan) => (
                        <option key={plan.plan_id} value={plan.plan_id}>
                          {plan.plan_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
              )}

              

              {/* Total Amount Input */}
              {selectedPlanObj?.plan_name && (
                <Form.Group as={Row} controlId="totalAmount" className="mt-3">
                  <Form.Label column sm={2}>Total Amount</Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      type="text"
                      placeholder="Total Amount"
                      value={totalAmount}
                      onChange={(e) => {
                        let value = Number(e.target.value);
                        if (value > maxAmount) {
                          setAmountError(`Total amount cannot exceed ₹${maxAmount}.`);
                          value = maxAmount;
                        } else if (value <= 0) {
                          setAmountError('Total amount must be greater than 0.');
                          value = 0;
                        } else {
                          setAmountError('');
                        }
                        setTotalAmount(value);
                      }}
                      min="0"
                    />
                  </Col>
                </Form.Group>
              )}

              {amountError && (
                <Alert variant="danger" className="mt-2">
                  {amountError}
                </Alert>
              )}

              {/* Remarks Input */}
              <Form.Group as={Row} controlId="remarks" className="mt-3">
                <Form.Label column sm={2}>Remarks</Form.Label>
                <Col sm={10}>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter remarks"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                  />
                </Col>
              </Form.Group>

              {/* Submit Button */}
              {totalAmount > 0 && (
                <div className="mt-4 text-center">
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? 'Submitting...' : 'Submit'}
                  </button>
                </div>
              )}
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default PreformaInvoice;
